import { type IconProps } from './types'

export function TikTokIcon({ width = '24', height = '24' }: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4791_1452)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0H54C57.3139 0 60 2.68608 60 6V54C60 57.3139 57.3139 60 54 60H6C2.68608 60 0 57.3139 0 54V6C0 2.68608 2.68608 0 6 0Z"
          fill="#010101"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.6757 55.2C39.5014 55.2 40.9815 53.7319 40.9815 51.9211C40.9815 50.1103 39.5014 48.642 37.6757 48.642H37.1777C39.0034 48.642 40.4835 50.1103 40.4835 51.9211C40.4835 53.7319 39.0034 55.2 37.1777 55.2H37.6757Z"
          fill="#EE1D51"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.1321 48.642H36.6341C34.8084 48.642 33.3281 50.1103 33.3281 51.9211C33.3281 53.7319 34.8084 55.2 36.6341 55.2H37.1321C35.3062 55.2 33.8261 53.7319 33.8261 51.9211C33.8261 50.1103 35.3062 48.642 37.1321 48.642Z"
          fill="#66C8CF"
        />
        <path
          d="M37.1546 53.5154C38.0426 53.5154 38.7624 52.8016 38.7624 51.9211C38.7624 51.0406 38.0426 50.3268 37.1546 50.3268C36.2667 50.3268 35.5469 51.0406 35.5469 51.9211C35.5469 52.8016 36.2667 53.5154 37.1546 53.5154Z"
          fill="#010101"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 47.16V48.822H13.9469V55.1552H15.8945V48.8669H17.4792L18.0226 47.16H12ZM27.9396 47.16V48.822H29.8865V55.1552H31.8341V48.8669H33.4188L33.9622 47.16H27.9396ZM18.3852 48.1032C18.3852 47.5824 18.8102 47.16 19.3354 47.16C19.861 47.16 20.2865 47.5824 20.2865 48.1032C20.2865 48.624 19.8612 49.0464 19.3354 49.0464C18.8102 49.0462 18.3852 48.624 18.3852 48.1032ZM18.3852 49.7204H20.2865V55.1552H18.3852V49.7204ZM21.1018 47.16V55.1552H23.0038V53.0892L23.5925 52.5497L25.4489 55.2H27.4865L24.8146 51.3372L27.2146 49.0013H24.9053L23.0038 50.8877V47.16H21.1018ZM41.6146 47.16V55.1552H43.5168V53.0892L44.1053 52.5497L45.9622 55.2H48L45.3281 51.3372L47.7281 49.0013H45.4188L43.5168 50.8877V47.16H41.6146Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.6804 19.4847C41.307 21.3612 44.5249 22.4655 48.0001 22.4655V15.7812C47.3423 15.7815 46.6863 15.7129 46.0429 15.5765V20.838C42.5679 20.838 39.3505 19.7338 36.7232 17.8572V31.4976C36.7232 38.3213 31.1888 43.8526 24.362 43.8526C21.8149 43.8526 19.4473 43.0829 17.4805 41.7629C19.7252 44.0568 22.8555 45.48 26.3187 45.48C33.146 45.48 38.6806 39.9488 38.6806 33.1248L38.6804 19.4847ZM41.0948 12.7412C39.7525 11.2755 38.8712 9.38117 38.6804 7.28693V6.42725H36.8257C37.2925 9.08885 38.8849 11.3628 41.0948 12.7412ZM21.7983 36.5268C21.0484 35.544 20.6431 34.3416 20.6449 33.1054C20.6449 29.9844 23.1764 27.4541 26.2995 27.4541C26.8815 27.4537 27.46 27.543 28.0148 27.7188V20.8853C27.3666 20.7966 26.7124 20.7589 26.0583 20.7728V26.0916C25.5033 25.9158 24.9245 25.8265 24.3423 25.8269C21.2192 25.8269 18.6879 28.3572 18.6879 31.4784C18.6879 33.6852 19.9532 35.5961 21.7983 36.5268Z"
          fill="#EE1D52"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.7229 17.8572C39.3502 19.7338 42.5677 20.838 46.0426 20.838V15.5765C44.1029 15.1637 42.3858 14.1504 41.0946 12.7412C38.8846 11.3628 37.2922 9.08885 36.8254 6.42725H31.9537V33.1246C31.9426 36.2369 29.4154 38.7569 26.299 38.7569C24.4626 38.7569 22.831 37.8821 21.7978 36.5268C19.9527 35.5961 18.6874 33.6852 18.6874 31.4784C18.6874 28.3572 21.2187 25.8269 24.3418 25.8269C24.9402 25.8269 25.5169 25.92 26.0578 26.0916V20.7728C19.351 20.9112 13.957 26.3885 13.957 33.1248C13.957 36.4875 15.3003 39.536 17.4802 41.7632C19.447 43.0832 21.8146 43.8528 24.3618 43.8528C31.1886 43.8528 36.7229 38.3213 36.7229 31.4979V17.8572Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.0426 15.5765V14.1538C44.2933 14.1564 42.5786 13.6668 41.0945 12.7409C42.4082 14.1785 44.1381 15.1698 46.0426 15.5765ZM36.8254 6.42725C36.7808 6.17291 36.7466 5.91686 36.7229 5.65973V4.80005H29.9962V31.4977C29.9854 34.6097 27.4584 37.1297 24.3418 37.1297C23.4266 37.1297 22.5629 36.9128 21.7978 36.5269C22.831 37.8821 24.4625 38.7569 26.299 38.7569C29.4151 38.7569 31.9426 36.2369 31.9536 33.1246V6.42725H36.8254ZM26.058 20.7728V19.2581C25.4959 19.1813 24.9292 19.1429 24.3619 19.1432C17.5344 19.1432 12 24.6747 12 31.4977C12 35.7754 14.1751 39.5453 17.4804 41.7629C15.3005 39.5357 13.9572 36.4872 13.9572 33.1246C13.9572 26.3885 19.351 20.9112 26.058 20.7728Z"
          fill="#69C9D0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.1771 55.2C39.0027 55.2 40.4831 53.7319 40.4831 51.9211C40.4831 50.1103 39.0027 48.642 37.1771 48.642H37.1319C35.3063 48.642 33.8262 50.1103 33.8262 51.9211C33.8262 53.7319 35.3063 55.2 37.1319 55.2H37.1771ZM35.547 51.9211C35.547 51.0403 36.267 50.3268 37.155 50.3268C38.0423 50.3268 38.7623 51.0403 38.7623 51.9211C38.7623 52.8019 38.0423 53.5159 37.155 53.5159C36.267 53.5156 35.547 52.8019 35.547 51.9211Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4791_1452">
          <rect width="60" height="60" rx="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
